var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBidSolid = function SvgBidSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.9 9.9a1 1 0 0 1 1.414 0l4.242 4.242a1 1 0 1 1-1.414 1.414L9.9 11.314a1 1 0 0 1 0-1.415Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m2.121 9.192 7.071-7.07 4.95 4.95-7.071 7.07-4.95-4.95Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.142 8.485a1 1 0 1 0 1.414-1.414l-1.414 1.414Zm-12.02-.707A1 1 0 0 0 .706 9.192l1.414-1.414Zm4.949 7.778a1 1 0 0 0 1.414-1.414l-1.414 1.414ZM9.192.707a1 1 0 1 0-1.414 1.414L9.192.707ZM2.828 9.9 9.9 2.83 8.485 1.413l-7.07 7.071L2.827 9.9Zm5.657-7.07 4.95 4.95 1.414-1.415-4.95-4.95-1.414 1.414Zm4.95 3.535-7.071 7.071 1.414 1.414 7.071-7.07-1.414-1.415Zm-5.657 7.071-4.95-4.95L1.414 9.9l4.95 4.95 1.414-1.415Zm5.657-5.657.707.707 1.414-1.414-.707-.707-1.414 1.414Zm-10.607.707-.707-.707L.707 9.192l.707.707 1.414-1.414Zm3.536 6.364.707.707 1.414-1.414-.707-.707-1.414 1.414ZM9.899 1.414 9.192.707 7.778 2.121l.707.707L9.9 1.414Z"
  })));
};
export default SvgBidSolid;